import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import ReactPlayer from 'react-player';
const videoStateIsPlaying = (videoElement) => {
    return (videoElement.currentTime > 0 && !videoElement.paused && !videoElement.ended && videoElement.readyState > 2);
};
const classNames = (...classes) => classes.filter(x => !!x).map(x => x.trim()).join(" ");
const DatoAsset = ({ alt, asset, style, className, objectFit = 'cover', objectPosition: overrideObjPosition, autoPlay = false, muted, isStatic, thumbnail, videoThumbnail, onPlayStateChange, onExitFullscreen, }) => {
    // Is an internal asset
    const objectPosition = overrideObjPosition || asset?.objectPosition;
    const reactPlayerRef = React.useRef();
    const [isPlaying, setIsPlaying] = React.useState(autoPlay && muted);
    const fullScreenEv = React.useCallback(() => {
        if (!document.fullscreenElement) {
            if (onExitFullscreen) {
                onExitFullscreen();
            }
            if (!muted && !asset.provider) {
                reactPlayerRef.current.getInternalPlayer().pause();
            }
        }
    }, [onExitFullscreen]);
    React.useEffect(() => {
        if (reactPlayerRef?.current) {
            window.addEventListener('fullscreenchange', fullScreenEv);
        }
        return () => {
            window.removeEventListener('fullscreenchange', fullScreenEv);
        };
    }, [fullScreenEv]);
    const defaultStyles = {
        objectFit,
        objectPosition,
        '--object-fit': objectFit,
        '--object-position': objectPosition,
        pointerEvents: muted ? 'none' : 'all',
        aspectRatio: (asset?.width && asset?.height && !asset.isImage) ? asset.width / asset.height : 'unset',
        ...(style || {}),
    };
    if (!asset) {
        return (React.createElement("div", { className: classNames('atl-asset', className), style: defaultStyles }));
    }
    if (asset && 'isImage' in asset) {
        const generatedAltData = asset?.smartTags && asset.smartTags.length > 0 ? `Image of ${asset.smartTags[0]}` : '';
        if (asset.format === 'svg') {
            return (React.createElement("img", { alt: alt || asset.alt || generatedAltData, src: asset.url || undefined, className: classNames('atl-asset', className), style: defaultStyles }));
        }
        if (asset.isImage && asset.gatsbyImageData) {
            return (React.createElement(GatsbyImage, { style: defaultStyles, className: classNames('atl-asset', className), alt: alt || asset.alt || generatedAltData, image: asset.gatsbyImageData, objectFit: objectFit, objectPosition: objectPosition }));
        }
    }
    if (asset?.video || (asset?.provider && asset?.url)) {
        if (isStatic) {
            return (React.createElement("img", { alt: "", src: thumbnail?.gatsbyImageData?.images?.fallback?.src || asset?.thumbnailUrl || asset?.video?.thumbnailUrl || '', className: classNames('atl-asset', className), style: defaultStyles }));
        }
        return (React.createElement("div", { role: "button", className: classNames('atl-asset', className), style: defaultStyles, "data-playing": isPlaying, onTouchEnd: () => {
                if (!muted && !asset.provider) {
                    if (videoStateIsPlaying(reactPlayerRef.current.getInternalPlayer())) {
                        try {
                            if (document.fullscreenElement) {
                                document.exitFullscreen();
                            }
                            //reactPlayerRef.current.getInternalPlayer().pause()
                        }
                        catch (e) {
                        }
                    }
                    else {
                        if (!asset.provider) {
                            reactPlayerRef.current.getInternalPlayer().play();
                            reactPlayerRef.current.getInternalPlayer().requestFullscreen();
                        }
                    }
                }
            }, onMouseUp: () => {
                if (!muted && !asset.provider) {
                    if (videoStateIsPlaying(reactPlayerRef.current.getInternalPlayer())) {
                        //reactPlayerRef.current.getInternalPlayer().pause()
                    }
                    else {
                        reactPlayerRef.current.getInternalPlayer().play();
                    }
                }
            } },
            React.createElement(ReactPlayer, { ref: reactPlayerRef, url: asset?.video?.streamingUrl || asset?.url || asset?.video?.url || undefined, config: {
                    attributes: {
                        poster: thumbnail?.gatsbyImageData?.images?.fallback?.src || asset?.thumbnailUrl || asset?.video?.thumbnailUrl,
                    },
                }, playing: autoPlay, controls: (!(autoPlay && muted)) && isPlaying, playsinline: muted, loop: autoPlay && muted, muted: muted, width: "100%", height: "100%", onReady: (e) => {
                    if (!muted) {
                        try {
                            //e.getInternalPlayer().play();
                            // eslint-disable-next-line no-empty
                        }
                        catch (e) {
                        }
                    }
                }, onPlay: () => {
                    setIsPlaying(true);
                    if (onPlayStateChange) {
                        onPlayStateChange('play');
                    }
                }, onPause: () => {
                    setIsPlaying(false);
                    if (onPlayStateChange) {
                        onPlayStateChange('pause');
                    }
                }, onEnded: () => {
                    setIsPlaying(false);
                    if (onPlayStateChange) {
                        onPlayStateChange('pause');
                    }
                } }),
            (!!asset?.thumbnailUrl && !isPlaying && !videoThumbnail) && (React.createElement("img", { alt: "", src: thumbnail?.gatsbyImageData?.images?.fallback?.src || asset?.thumbnailUrl || asset?.video?.thumbnailUrl || '', className: classNames('atl-asset', className), style: {
                    ...defaultStyles,
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    pointerEvents: 'none'
                } })),
            (!!asset?.thumbnailUrl && !isPlaying && videoThumbnail) && (React.createElement("video", { src: videoThumbnail, className: classNames('atl-asset', className), style: {
                    ...defaultStyles,
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    pointerEvents: 'none'
                }, autoPlay: true, muted: true, loop: true, playsInline: true })),
            (!autoPlay && !muted && (!asset?.provider || (asset?.provider && asset?.thumbnailUrl))) && (React.createElement("div", { className: "play" },
                React.createElement("svg", { width: "63", height: "63", viewBox: "0 0 63 63", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("circle", { cx: "31.5", cy: "31.5", r: "31", stroke: "white" }),
                    React.createElement("path", { d: "M23.25 20.5V42.5C23.2499 42.7446 23.3151 42.9849 23.4389 43.1959C23.5627 43.4069 23.7405 43.5811 23.954 43.7005C24.1676 43.8199 24.4091 43.8802 24.6537 43.875C24.8983 43.8699 25.1371 43.7997 25.3455 43.6715L43.2205 32.6715C43.4207 32.5484 43.586 32.3762 43.7007 32.1711C43.8154 31.966 43.8756 31.7349 43.8756 31.5C43.8756 31.265 43.8154 31.0339 43.7007 30.8288C43.586 30.6238 43.4207 30.4515 43.2205 30.3285L25.3455 19.3285C25.1371 19.2003 24.8983 19.13 24.6537 19.1249C24.4091 19.1198 24.1676 19.18 23.954 19.2994C23.7405 19.4188 23.5627 19.593 23.4389 19.804C23.3151 20.0151 23.2499 20.2553 23.25 20.5Z", fill: "white" })),
                React.createElement("span", null, "Play Video")))));
    }
    // Nothing exists
    return (React.createElement("div", { className: classNames('atl-asset', className), style: defaultStyles }));
};
export default DatoAsset;
//# sourceMappingURL=index.js.map